import React from 'react';
import Icon from '../../../components/AppIcon';

const TeamMetrics = () => {
  const metrics = [
    {
      value: "30+",
      label: "Years Combined Experience",
      description: "Collective expertise across diverse industries and markets",
      icon: "Clock",
      color: "text-accent"
    },
    {
      value: "50+",
      label: "Valuations Completed",
      description: "Valuation and financial analysis engagements completed",
      icon: "TrendingUp",
      color: "text-success"
    },
    // {
    //   value: "63",
    //   label: "Court Appearances",
    //   description: "Expert testimony in complex litigation matters",
    //   icon: "Scale",
    //   color: "text-warning"
    // },
    {
      value: "200+",
      label: "Satisfied Clients",
      description: "Long-term relationships built on trust and results",
      icon: "Users",
      color: "text-accent"
    },
    // {
    //   value: "6",
    //   label: "GCC Countries Served",
    //   description: "Regional coverage with local market expertise",
    //   icon: "Globe",
    //   color: "text-success"
    // },
    // {
    //   value: "98%",
    //   label: "Client Retention Rate",
    //   description: "Clients who return for additional services",
    //   icon: "Heart",
    //   color: "text-error"
    // }
  ];

  const capabilities = [
    // {
    //   title: "Multilingual Expertise",
    //   description: "Fluent in English and Arabic with cultural sensitivity",
    //   icon: "Languages",
    //   details: [
    //     "Native Arabic speakers",
    //     "Professional English proficiency",
    //     "Cultural business understanding",
    //     "Bilingual report preparation"
    //   ]
    // },
    {
      title: "Technical Competence",
      description: "Advanced valuation methodologies and financial modeling",
      icon: "Calculator",
      details: [
        "DCF and comparable analysis",
        "Monte Carlo simulations",
        "Sensitivity analysis",
        "Risk assessment modeling"
      ]
    },
    {
      title: "Industry Specialization",
      description: "Deep sector knowledge across key industries",
      icon: "Building",
      details: [
        "Real estate and construction",
        "Oil & gas and petrochemicals",
        "Financial services",
        "Technology and startups"
      ]
    },
    // {
    //   title: "Communication Skills",
    //   description: "Clear, compelling presentation of complex concepts",
    //   icon: "MessageSquare",
    //   details: [
    //     "Executive-level presentations",
    //     "Court testimony experience",
    //     "Technical report writing",
    //     "Stakeholder management"
    //   ]
    // }
  ];

  return (
    <div className="bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-semibold text-text-primary mb-4">
            Team Expertise & Performance Metrics
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Our track record speaks to our commitment to excellence and the trust our clients place in our expertise. These metrics reflect our collective experience and successful outcomes.
          </p>
        </div>

        {/* Metrics Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {metrics?.map((metric, index) => (
            <div key={index} className="bg-card rounded-xl shadow-brand border border-border p-6 text-center hover-lift">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-muted rounded-full mb-4">
                <Icon name={metric?.icon} size={32} className={metric?.color} />
              </div>
              
              <div className="text-3xl font-bold text-text-primary mb-2">
                {metric?.value}
              </div>
              
              <div className="text-lg font-semibold text-text-primary mb-3">
                {metric?.label}
              </div>
              
              <p className="text-sm text-text-secondary">
                {metric?.description}
              </p>
            </div>
          ))}
        </div>

        {/* Capabilities Section */}
        {/* <div className="bg-muted/30 rounded-xl p-8">
          <h3 className="text-2xl font-semibold text-text-primary text-center mb-12">
            Core Capabilities & Selection Criteria
          </h3>
          
          <div className="grid lg:grid-cols-2 gap-8">
            {capabilities?.map((capability, index) => (
              <div key={index} className="bg-card rounded-lg shadow-brand border border-border p-6">
                <div className="flex items-start space-x-4 mb-4">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center">
                      <Icon name={capability?.icon} size={24} className="text-accent" />
                    </div>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-text-primary mb-2">
                      {capability?.title}
                    </h4>
                    <p className="text-text-secondary mb-4">
                      {capability?.description}
                    </p>
                  </div>
                </div>
                
                <div className="space-y-2">
                  {capability?.details?.map((detail, detailIndex) => (
                    <div key={detailIndex} className="flex items-start space-x-3">
                      <Icon name="Check" size={16} className="text-success mt-0.5 flex-shrink-0" />
                      <span className="text-sm text-text-secondary">{detail}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div> */}

        {/* Professional Network */}
        <div className="mt-16 text-center">
          <h3 className="text-2xl font-semibold text-text-primary mb-8">
            Professional Network & Industry Connections
          </h3>
          
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="bg-card rounded-lg shadow-brand border border-border p-6">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-accent/10 rounded-full mb-4">
                <Icon name="Linkedin" size={24} className="text-accent" />
              </div>
              <div className="text-2xl font-bold text-text-primary mb-2">2,500+</div>
              <div className="text-sm text-text-secondary">Professional Connections</div>
            </div>
            
            <div className="bg-card rounded-lg shadow-brand border border-border p-6">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-success/10 rounded-full mb-4">
                <Icon name="Users" size={24} className="text-success" />
              </div>
              <div className="text-2xl font-bold text-text-primary mb-2">6+</div>
              <div className="text-sm text-text-secondary">Industry Associations</div>
            </div>
            
            {/* <div className="bg-card rounded-lg shadow-brand border border-border p-6">
              <div className="inline-flex items-center justify-center w-12 h-12 bg-warning/10 rounded-full mb-4">
                <Icon name="Award" size={24} className="text-warning" />
              </div>
              <div className="text-2xl font-bold text-text-primary mb-2">15+</div>
              <div className="text-sm text-text-secondary">Speaking Engagements</div>
            </div> */}
          </div>
          
          <p className="text-sm text-text-secondary mt-8 max-w-2xl mx-auto">
            Our extensive professional network enables us to stay current with market trends, regulatory changes, and best practices while maintaining the highest standards of client confidentiality.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TeamMetrics;